import React from 'react';
import { Container, Typography, Paper } from '@mui/material';
import './LegalPages.css';

const TeslimatIade = () => {
  return (
    <Container maxWidth="md" className="legal-container">
      <Paper elevation={3} className="legal-paper">
        <Typography variant="h4" component="h1" gutterBottom>
          Teslimat ve İade Koşulları
        </Typography>

        <div className="section">
          <Typography variant="h6" className="section-title">
            1. Dijital Hizmet Teslimatı
          </Typography>
          <Typography variant="body1" paragraph>
            HOPS platformunda satın alınan kontör paketleri, dijital hizmet kapsamında değerlendirilmektedir. 
            Ödemenin başarıyla tamamlanmasının ardından kontörler anında hesabınıza tanımlanır ve 
            kullanıma hazır hale gelir.
          </Typography>
        </div>

        <div className="section">
          <Typography variant="h6" className="section-title">
            2. Aktivasyon ve Kullanım
          </Typography>
          <Typography variant="body1" paragraph>
            Satın alınan kontörler otomatik olarak aktive edilir ve hesabınıza tanımlanır. 
            Kontörlerinizin aktivasyon durumunu ve bakiyenizi platform üzerinden kontrol edebilirsiniz. 
            Herhangi bir teknik sorun yaşamanız durumunda müşteri hizmetlerimiz size yardımcı olacaktır.
          </Typography>
        </div>

        <div className="section">
          <Typography variant="h6" className="section-title">
            3. İade ve İptal Politikası
          </Typography>
          <Typography variant="body1" paragraph>
            Dijital hizmet kapsamında değerlendirilen kontör satışlarında, hizmetin tesliminin/ifasının 
            başladığı an itibarıyla iade ve iptal hakkı bulunmamaktadır. Bu durum, 6502 Sayılı Tüketicinin 
            Korunması Hakkında Kanun'un ilgili maddeleri uyarınca belirlenmiştir.
          </Typography>
        </div>

        <div className="section">
          <Typography variant="h6" className="section-title">
            4. Teknik Sorunlar
          </Typography>
          <Typography variant="body1" paragraph>
            Kontör yükleme işlemi sırasında teknik bir sorun yaşanması durumunda, işlem kaydınız ve 
            ödeme dekontunuz ile birlikte müşteri hizmetlerimize başvurabilirsiniz. Teknik ekibimiz 
            en kısa sürede sorununuzu çözecektir.
          </Typography>
        </div>

        <div className="section">
          <Typography variant="h6" className="section-title">
            5. Fatura ve Ödeme Belgeleri
          </Typography>
          <Typography variant="body1" paragraph>
            Kontör satın alma işleminize ait fatura, kayıtlı e-posta adresinize otomatik olarak 
            gönderilecektir. Faturanızı platform üzerinden de görüntüleyebilir ve indirebilirsiniz.
          </Typography>
        </div>


        <div className="contact-info">
          <Typography variant="h6" gutterBottom>
            Destek ve İletişim
          </Typography>
          <Typography variant="body1">
            Teslimat ve kontör aktivasyonu ile ilgili sorularınız için:
          </Typography>
          <Typography variant="body1">
            E-posta: info@hopssoftware.com
          </Typography>
          <Typography variant="body1">
            Telefon: +90 552 464 11 16
          </Typography>
          <Typography variant="body1">
            Çalışma Saatleri: Hafta içi 09:00 - 18:00
          </Typography>
        </div>
      </Paper>
    </Container>
  );
};

export default TeslimatIade; 